import { BottomNavigation, BottomNavigationProps } from "@mui/material";
import React from "react";
import { theme } from "../../../theme";

const BottomBar: React.FC<BottomNavigationProps> = (
  props: BottomNavigationProps
) => {
  return (
    <BottomNavigation
      {...props}
      sx={{
        ...(props.sx ?? {}),
        bottom: 0,
        left: 0,
        py: 2,
        width: "100%",
        height: "auto",
        position: "fixed",
        backgroundColor: theme.palette.background.paper,
        zIndex: theme.zIndex.appBar,
        [theme.breakpoints.up('md')]: {
          // marginLeft: `${theme.mixins.sidebar.width}px`,
          width: `calc(100% - ${theme.mixins.sidebar.width}px)`
        },
      }}
    >
      {props.children}
    </BottomNavigation>
  );
};

export default BottomBar;
